function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "document",
  transform: "translate(-4.511 -2.251)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_11715",
  "data-name": "Path 11715",
  d: "M35.6,12.94,25.346,2.69a1.328,1.328,0,0,0-1.024-.439H9.679A2.936,2.936,0,0,0,6.75,5.18V40.322a2.936,2.936,0,0,0,2.929,2.929H33.107a2.936,2.936,0,0,0,2.929-2.929V13.964A1.331,1.331,0,0,0,35.6,12.94ZM24.321,5.764l8.2,8.2h-8.2Zm8.786,34.557H9.679V5.178H21.393v8.786a2.936,2.936,0,0,0,2.929,2.929h8.786Z",
  transform: "translate(0 0)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11716",
  "data-name": "Path 11716",
  d: "M11.25,24.75H28.821v2.929H11.25Z",
  transform: "translate(1.357 6.785)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_11717",
  "data-name": "Path 11717",
  d: "M11.25,18H45.015V30.008H11.25Z",
  transform: "translate(-6.739 4.75)",
  fill: "#ac1ede"
}), /*#__PURE__*/React.createElement("text", {
  id: "Solutions_designed",
  "data-name": "Solutions designed",
  transform: "translate(10.607 24.251)",
  fill: "#ac1ede",
  fontSize: 10,
  fontFamily: "SegoeUI, Segoe UI",
  letterSpacing: "0.05em"
}, /*#__PURE__*/React.createElement("tspan", {
  x: 1.643,
  y: 11
}, "CSV")));

var SvgDocument = function SvgDocument(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.765,
    height: 41,
    viewBox: "0 0 33.765 41",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDocument, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/document.8d4bf142.svg";
export { ForwardRef as ReactComponent };